import { type ArchiveRecordStep } from '../actionSectionTypes';

export const archiveRecordStepRemoveVariable = (
  step: ArchiveRecordStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  if (step.details.automationVariable?.value === variableName) {
    const nextStep = {
      ...step,
      hasError: true,
      details: {
        ...step.details,
        automationVariable: {
          ...step.details.automationVariable,
          deleted: true,
        },
      },
    };
    if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
    return {
      nextStep,
      nextErrorIds,
    };
  }

  return {
    nextStep: step,
    nextErrorIds,
  };
};
